/* Sound Room for the public welcome page. Renders nothing until samples are
   published in src/data/audioShowcase.js, so the page never shows an empty
   audio section. Each sample uses its own native audio control and loads
   only when played (preload="none"). */
export default function AudioShowcase({ items = [] }) {
  if (!items.length) return null;

  return (
    <section
      id="sound"
      data-testid="section-audio"
      className="relative bg-[#080910] border-y border-white/8 py-24 sm:py-28"
    >
      <div className="max-w-[1280px] mx-auto px-5">
        <div className="text-[11px] font-mono uppercase tracking-[0.24em] text-[#8c7cff] mb-3">The Sound Room</div>
        <h2 className="font-display text-4xl sm:text-5xl font-bold leading-[1.04]">Audio Vyom has created</h2>
        <p className="text-sm sm:text-base text-slate-400 mt-3 max-w-xl">Voice, music and sound from Vyom productions. Press play on any sample.</p>
        <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
          {items.map((item) => (
            <li
              key={item.slug}
              data-testid={`audio-sample-${item.slug}`}
              className="rounded-2xl p-5 bg-white/[0.03] ring-1 ring-white/10"
            >
              {item.category && (
                <div className="text-[10px] font-mono uppercase tracking-wider text-[#c9c1ff]">{item.category}</div>
              )}
              <div className="font-display font-semibold text-white mt-2">{item.title}</div>
              <p className="text-sm text-slate-400 mt-1.5 leading-relaxed">{item.description}</p>
              <audio
                controls
                preload="none"
                src={item.src}
                aria-label={`${item.title} sample`}
                className="w-full mt-4"
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
